import React, {Component} from 'react';
import styled from 'styled-components'
import {Card} from "./DataCard";
import {LicencePlate} from "../LicensPlate/LicensPlateComponent";

const StyledDataContainer = styled.div`
  .title{
    display: block;
  }
  .value{
    display: block;
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
`

class CarDataCard extends Component {
    render() {
        const {data} = this.props
        console.log(data)
        return (
            <Card>
                <StyledDataContainer>

                    <span className="title">Marka:</span>
                    <span className="value">{data.carBrand}</span>

                    <span className="title">Tipus:</span>
                    <span className="value">{data.carType}</span>

                    <LicencePlate value={data.carPlate} disabled={true}/>
                </StyledDataContainer>
            </Card>
        );
    }
}

export default CarDataCard;